import React, { FunctionComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useSelect } from '../../../../../utils/selector.utils';
import { WidgetsDragDropContext } from '../../drag-drop-contexts/WidgetsDragDropContext';
import { WidgetDialogItem } from './WidgetDialogItem';
import { userSettingsPageSelectors } from '../../../../../app/page/page-storage/user-settings/user-settings.selectors';

export const WidgetsDialogList: FunctionComponent = () => {
  const widgets = useSelect(userSettingsPageSelectors.selectUserWidgets) ?? [];

  return (
    <WidgetsDragDropContext>
      <Droppable droppableId={`widgets`}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} id="widgetsList">
            {widgets.map((widget, index) => (
              <Draggable key={widget.key} draggableId={widget.key} index={index}>
                {(provided) => <WidgetDialogItem widget={widget} provided={provided} />}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </WidgetsDragDropContext>
  );
};
